// zoom-lightbox-swiper.js
(function () {
  const DEFAULT_SCALE = 2.2; // change zoom level if needed
  const MAX_SCALE = 4;
  const MIN_SCALE = 1;

  // selector for images inside your modal (from the markup you provided)
  const IMG_SELECTOR = '.product-media-modal .swiper-slide img.global-media-settings';

  function makeZoomable(img) {
    if (!img || img.__zoomInit) return;
    img.__zoomInit = true;

    // wrap in container if not already
    let container;
    if (img.parentElement && img.parentElement.classList.contains('zoom-container')) {
      container = img.parentElement;
    } else {
      container = document.createElement('div');
      container.className = 'zoom-container';
      img.parentNode.insertBefore(container, img);
      container.appendChild(img);
    }

    let scale = 1;
    let translate = { x: 0, y: 0 };
    let isPointerDown = false;
    let lastPointer = null;
    let startTranslate = { x: 0, y: 0 };

    function apply() {
      img.style.transform = `translate(${translate.x}px, ${translate.y}px) scale(${scale})`;
      img.classList.toggle('zoomed', scale > 1);
    }

    function reset() {
      scale = 1;
      translate = { x: 0, y: 0 };
      apply();
    }

    function clampTranslate() {
      const imgRect = img.getBoundingClientRect();
      const contRect = container.getBoundingClientRect();
      const scaledW = imgRect.width * scale;
      const scaledH = imgRect.height * scale;

      // when image is smaller than container horizontally/vertically, center it
      if (scaledW <= contRect.width) {
        translate.x = 0;
      } else {
        const minX = contRect.width - scaledW;
        const maxX = 0;
        translate.x = Math.max(minX, Math.min(maxX, translate.x));
      }
      if (scaledH <= contRect.height) {
        translate.y = 0;
      } else {
        const minY = contRect.height - scaledH;
        const maxY = 0;
        translate.y = Math.max(minY, Math.min(maxY, translate.y));
      }
    }

    function zoomAt(clientX, clientY, toScale) {
      const rect = img.getBoundingClientRect();
      const offsetX = clientX - rect.left;
      const offsetY = clientY - rect.top;
      const oldScale = scale;
      scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, toScale));
      // adjust translate so the point under cursor remains stable
      translate.x = translate.x - (offsetX * (scale / oldScale - 1));
      translate.y = translate.y - (offsetY * (scale / oldScale - 1));
      clampTranslate();
      apply();
    }

    // pointer events for pan
    img.addEventListener('pointerdown', (e) => {
      if (scale <= 1) return;
      isPointerDown = true;
      lastPointer = { x: e.clientX, y: e.clientY };
      startTranslate = { ...translate };
      img.setPointerCapture && img.setPointerCapture(e.pointerId);
    });

    img.addEventListener('pointermove', (e) => {
      if (!isPointerDown) return;
      const dx = e.clientX - lastPointer.x;
      const dy = e.clientY - lastPointer.y;
      translate.x = startTranslate.x + dx;
      translate.y = startTranslate.y + dy;
      clampTranslate();
      apply();
    });

    ['pointerup', 'pointercancel', 'pointerout', 'pointerleave'].forEach(evt => {
      img.addEventListener(evt, (e) => {
        if (!isPointerDown) return;
        isPointerDown = false;
        try { img.releasePointerCapture && img.releasePointerCapture(e.pointerId); } catch (err) {}
      });
    });

    // double-click / double-tap to toggle zoom
    let lastTap = 0;
    img.addEventListener('click', (e) => {
      const now = Date.now();
      if (now - lastTap < 300) {
        // toggle
        if (scale === 1) {
          zoomAt(e.clientX, e.clientY, DEFAULT_SCALE);
        } else {
          reset();
        }
      }
      lastTap = now;
    });

    // wheel to zoom (ctrl+wheel or normal wheel - we handle small deltas)
    img.addEventListener('wheel', (e) => {
      // prefer ctrl+wheel on desktop to avoid interfering with page scroll; but if already zoomed allow wheel
      const shouldZoom = e.ctrlKey || scale > 1;
      if (!shouldZoom) return;
      e.preventDefault();
      const delta = -e.deltaY;
      const factor = delta > 0 ? 1.08 : 0.92;
      zoomAt(e.clientX, e.clientY, scale * factor);
    }, { passive: false });

    // when image src changes (lazy load), reset
    const srcObserver = new MutationObserver(() => reset());
    srcObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });

    // expose reset for external use
    img.__zoomReset = reset;
  }

  // Initialize all images matching selector
  function initAll() {
    document.querySelectorAll(IMG_SELECTOR).forEach(makeZoomable);
  }

  // When active slide changes, reset non-active images transforms
  function observeSlideChanges() {
    // watch for class changes on any swiper-slide
    const slides = document.querySelectorAll('.product-media-modal .swiper-slide');
    slides.forEach((slide) => {
      const mo = new MutationObserver((mutations) => {
        mutations.forEach(m => {
          if (m.attributeName === 'class') {
            // if this slide became inactive or active, reset if becoming inactive
            const img = slide.querySelector('img.global-media-settings');
            if (!img) return;
            const isActive = slide.classList.contains('swiper-slide-active');
            if (!isActive && img.__zoomReset) {
              img.__zoomReset();
            }
            // ensure pointer events handled by CSS (.swiper-slide-active pointer-events:auto)
          }
        });
      });
      mo.observe(slide, { attributes: true });
    });
  }

  // Detect modal open/close and cleanup
  function observeModal() {
    const modal = document.querySelector('product-modal.product-media-modal');
    if (!modal) return;

    // attribute observer for `open` attribute
    const am = new MutationObserver((ms) => {
      ms.forEach(m => {
        if (m.attributeName === 'open') {
          const isOpen = modal.hasAttribute('open');
          if (isOpen) {
            // modal opened: initialize images after a short tick (Swiper may lazy mount)
            setTimeout(() => {
              initAll();
              observeSlideChanges();
            }, 50);
          } else {
            // modal closed: reset all transforms
            document.querySelectorAll(IMG_SELECTOR).forEach(img => {
              if (img && img.__zoomReset) img.__zoomReset();
            });
          }
        }
      });
    });
    am.observe(modal, { attributes: true });
    // initial run if already open on load
    if (modal.hasAttribute('open')) {
      setTimeout(() => {
        initAll();
        observeSlideChanges();
      }, 50);
    }
  }

  // Also initialize existing ones on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      observeSlideChanges();
      observeModal();
    });
  } else {
    initAll();
    observeSlideChanges();
    observeModal();
  }

  // Finally, observe for new modals (in case of dynamic mounting)
  const bodyObserver = new MutationObserver((ms) => {
    ms.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches('product-modal.product-media-modal')) {
          // run init when new modal appears
          setTimeout(() => { initAll(); observeSlideChanges(); }, 50);
        } else if (node.querySelector && node.querySelector('product-modal.product-media-modal')) {
          setTimeout(() => { initAll(); observeSlideChanges(); }, 50);
        }
      });
    });
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

})();
